import React, { useEffect } from "react";
import BookingOP from "./BookingOP";
import "../CustomCSS/BookingModal.css";

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

const BookingModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;

    // lock scroll on html+body and compensate for scrollbar to avoid layout shift
    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlPaddingRight = document.documentElement.style.paddingRight || "";

    const sb = getScrollbarWidth();
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    if (sb > 0) {
      document.documentElement.style.paddingRight = `${sb}px`;
    }

    return () => {
      // restore
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.paddingRight = prevHtmlPaddingRight;
    };
  }, [isOpen]);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    if (isOpen) window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="simple-modal-overlay" onClick={onClose}>
      <div className="simple-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <button className="simple-modal-close" onClick={onClose} aria-label="Close">✕</button>
        <div className="simple-modal-body">
          <BookingOP />
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
